export const accountTypesConstants = {
  CASA_ACCOUNT_TYPE: "CASA",
  CREDIT_ACCOUNT_TYPE: "CREDIT",
  CURRENT_ACCOUNT_TYPE: "CURRENT",
  SAVING_ACCOUNT_TYPE: "SAVING",
  FIXED_DEPOSITS_TYPE: "DEPOSITS",
  ALL_ACCOUNT_TYPE: "ALL",

  ACCOUNTS_TAB_TYPE: "ACCOUNTS",
  CARDS_TAB_TYPE: "CARDS",

  BILLING_STATUS_RECENT: "RECENT",
  BILLING_STATUS_UNBILLED: "UNBILLED",

  BILLING_STATUS_UNBILLED_CAMELCASE: "Unbilled",
  BILLING_STATUS_PENDING_LOWERCASE: "pending",

  ACTIVITY_TAB_TYPE_RECENT: "RECENT",
  ACTIVITY_TAB_TYPE_UNBILLED: "UNBILLED",
  ACTIVITY_TAB_TYPE_STATEMENT: "STATEMENT",

  CREDIT_CARD_ACCOUNT_TYPE: "CREDIT",
  DEBIT_CARD_ACCOUNT_TYPE: "DEBIT",
  LOANS_ACCOUNT_TYPE: "LENDING",

  ELIGIBLE_OPERATING_TYPE_LIST: ["VIEW_AND_TRANSFERS"],

  DEBIT_CARD_INDICATOR_NAME: "DR",
  CARD_STATUS_PENDING_LOWERCASE: "pending",

  REGISTERED_ACCOUNT_TYPE_LIST: [
    {
      value: "CASA",
      label: "Savings",
    },
    {
      value: "FD",
      label: "Fixed Deposits",
    },
    // {
    //   value: "LEAS",
    //   label: "Lending",
    // },
    // {
    //   value: "PAWNING",
    //   label: "Pawning",
    // },
  ],
};
